<script>
import { EventTag } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit EventTag',
      addRoute: { name: 'Add EventTag' },
      verboseName: 'Tag wydarzenia',
      verboseNamePlural: 'Tagi wydarzeń',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name', label: 'nazwa' }
      ]
    }
  },
  computed: {
    service() {
      return EventTag
    }
  }
}
</script>
